import { render, staticRenderFns } from "./EmptyHelper.vue?vue&type=template&id=bbc59d7c&scoped=true"
import script from "./EmptyHelper.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyHelper.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EmptyHelper.vue?vue&type=style&index=0&id=bbc59d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc59d7c",
  null
  
)

export default component.exports